export * from './useCompactPeopleSecondaryMenu.types';
export { default as useCompactPeopleSecondaryMenu } from './useCompactPeopleSecondaryMenu';
